import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './Carousel';
import { Card, CardContent } from './Card';
const REVIEWS = [{
  name: 'Michael T.',
  location: 'The Woodlands, TX',
  text: 'Baxter Family Plumbing installed our new tankless water heater. They were professional, fast, and the price was exactly what they quoted. Highly recommend!',
  service: 'Water Heater Install'
}, {
  name: 'Sarah J.',
  location: 'Houston, TX',
  text: 'We had a major leak under our sink and Brett came out the same day. He fixed it quickly and even checked our other fixtures. True professional.',
  service: 'Leak Repair'
}, {
  name: 'David R.',
  location: 'Galveston, TX',
  text: 'Showed up on time, worked efficiently, and the results speak for themselves. Best plumbing service I have used in Texas. Highly recommend these guys.',
  service: 'Drain Cleaning'
}, {
  name: 'Amanda L.',
  location: 'Conroe, TX',
  text: 'They handle all the plumbing for our commercial storefront. Always reliable and they do great work. We set up a recurring maintenance schedule.',
  service: 'Commercial Plumbing'
}];
export function Reviews() {
  return <section id="reviews" className="py-24 bg-surface border-y border-accent/10 overflow-hidden" data-id="element-180">
      <div className="container mx-auto px-4" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-183">
            Customer <span className="text-accent" data-id="element-184">Reviews</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-185">
            Do not just take our word for it. See what your neighbors are saying
            about our plumbing services.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative px-12" data-id="element-186">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-187">
            <CarouselContent className="-ml-4" data-id="element-188">
              {REVIEWS.map((review, index) => <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3" data-id="element-189">
                  <Card className="bg-dark border-accent/20 h-full relative overflow-hidden group" data-id="element-190">
                    <div className="absolute -right-4 -bottom-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-191">
                      <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-192">
                        <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="#dc2626" data-id="element-193" />
                      </svg>
                    </div>
                    <CardContent className="p-6 flex flex-col h-full relative z-10" data-id="element-194">
                      <div className="flex gap-1 mb-4" data-id="element-195">
                        {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-accent-light text-accent-light" data-id="element-196" />)}
                      </div>
                      <Quote className="h-8 w-8 text-accent/30 mb-4" data-id="element-197" />
                      <p className="text-slate-300 mb-6 flex-grow italic" data-id="element-198">
                        "{review.text}"
                      </p>
                      <div className="mt-auto border-t border-accent/20 pt-4" data-id="element-199">
                        <p className="font-bold text-white" data-id="element-200">{review.name}</p>
                        <div className="flex justify-between items-center mt-1" data-id="element-201">
                          <p className="text-sm text-slate-400" data-id="element-202">
                            {review.location}
                          </p>
                          <span className="text-xs font-bold text-accent uppercase tracking-wider bg-surface px-2 py-1 rounded" data-id="element-203">
                            {review.service}
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="bg-dark border-accent/30 text-white hover:bg-accent hover:text-white -left-4 md:-left-12" data-id="element-204" />
            <CarouselNext className="bg-dark border-accent/30 text-white hover:bg-accent hover:text-white -right-4 md:-right-12" data-id="element-205" />
          </Carousel>
        </div>
      </div>
    </section>;
}